var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 121,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 82.899h-4.277V48.497c0-12.486-10.163-22.645-22.654-22.645-12.492 0-22.654 10.159-22.654 22.645v34.402H77.8l-.555-34.402c0-13.927 9.234-25.458 27.486-25.258C118.664 23.392 130 34.57 130 48.497v34.402z",
    fill: "#A0EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65D6F8",
    d: "M62.174 118.068h9.42v-35.17h-9.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.28,
    fill: "#000",
    d: "M71.594 98.599l-9.42-9.147v-6.553h9.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.865 82.899V54.667c0-17.012 13.862-30.802 30.964-30.802h40.439c21.877 1.176 30.964 10.751 30.964 28.037v30.997H23.865z",
    fill: "#65D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05 47.73H70.965v35.169h55.266v-31.17c0-1.384-.065-2.714-.183-4",
    fill: "#44C8DC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65EAEF",
    d: "M70.338 77.874h55.894V64.058H70.338z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.594 82.899V48.466c0-13.24-10.684-23.973-23.864-23.973-13.18 0-23.865 10.733-23.865 23.973v34.433h47.73z",
    fill: "#606075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85 82.899h-2.598V48.495c0-12.486-10.104-22.645-22.523-22.645-12.418 0-22.522 10.159-22.522 22.645V82.9H22.61V48.495c0-13.927 11.269-25.258 25.12-25.258 13.852 0 25.121 11.33 25.121 25.258V82.9z",
    fill: "#A0EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.338 78.502H2.394C1.072 78.502 0 79.487 0 80.7 0 81.915 1.072 82.9 2.394 82.9h67.944v-4.397z",
    fill: "#32D6EA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1443C",
    d: "M83.527 1.256l19.468 7.537-19.468 7.536z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44 35.483c0 1.908-1.608 3.454-3.59 3.454H77.068c-1.983 0-3.59-1.546-3.59-3.454 0-1.908 1.607-3.454 3.59-3.454h36.78c1.983 0 3.59 1.546 3.59 3.454",
    fillOpacity: 0.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71 73.478h3.517c2.67 0 4.836-2.108 4.836-4.71 0-2.601-2.165-4.71-4.836-4.71h-3.518c-2.67 0-4.835 2.109-4.835 4.71 0 2.602 2.165 4.71 4.835 4.71",
    fillOpacity: 0.1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.502 68.768a4.71 4.71 0 119.42 0 4.71 4.71 0 01-9.42 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.014 1.367C81.014.612 81.858 0 82.9 0c1.04 0 1.884.612 1.884 1.367v68.232c0 .755-.843 1.367-1.884 1.367-1.04 0-1.885-.612-1.885-1.367V1.367z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.899 70.966c1.053-.06 1.884-.64 1.884-1.356V1.356C84.783.64 83.952.06 82.899 0v70.966z",
    fill: "#B4CCC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.986 120.58c0-3.469 8.013-6.28 17.898-6.28s17.899 2.811 17.899 6.28H48.986z",
    fill: "#65D6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.174 75.382c0 1.724-1.176 3.12-2.628 3.12h-46.87c-1.451 0-2.628-1.396-2.628-3.12V48.338c0-1.724 1.177-3.12 2.628-3.12h46.87c1.452 0 2.628 1.396 2.628 3.12v27.044z",
    fill: "#FFD829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.302 45.217l-7.004 8.372.726 1.293a2.37 2.37 0 00-.883 1.843c0 1.312 1.05 2.376 2.347 2.376.561-.002.824-.002.787 0 1.27.086 2.284 1.249 2.284 2.557 0 1.071-.68 1.966-1.623 2.306h-5.21c-1.348 0-2.441 1.106-2.441 2.47 0 1.365 1.093 2.47 2.44 2.47h3.592a2.444 2.444 0 012.049 2.417c0 1.227-.89 2.224-2.049 2.416h-7.171c-1.348 0-2.44 1.105-2.44 2.47 0 1.047.644 1.936 1.553 2.295h15.285c1.453 0 2.63-1.396 2.63-3.12V48.338c0-1.724-1.177-3.12-2.63-3.12h-2.242z",
    fill: "#F1BF33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.559 45.217c-.357 0-.93.104-1.37.55l22.986 26.718c1.188 1.342 3.096 1.321 4.263-.044l22.63-26.617c-.463-.553-1.217-.607-1.886-.607H12.56z",
    fillOpacity: 0.28,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.858 45.217c-.792 0-1.212.164-1.647.53l23.299 21.89c1.173 1.103 3.057 1.087 4.209-.036L61.056 45.81c-.458-.455-.846-.592-1.852-.592H12.858z",
    fill: "#FFE56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.974 62.884c-.633.692-1.7.731-2.38.088L21.262 51.32a1.73 1.73 0 01-.086-2.418c.633-.691 1.7-.731 2.38-.087l12.332 11.65a1.73 1.73 0 01.086 2.418",
    fillOpacity: 0.5,
    fill: "#FFF"
  }))));
}
export default __webpack_public_path__ + "3692fbbf32cf355021035c7dc9e4accb.svg";
export { SvgMailbox as ReactComponent };